/* Este archivo existe para ser sobreescrito por el proyecto que utilice la layer base. 
La funcion alInit se ejecuta al inicio de la aplicación, es llamada por el plugin 01.inicio.ts. */


export async function alInit() {
  consolo.log('alInit layer base')
}